import type { PaletteMode } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function  useThemeMode(): PaletteMode {
    const theme = useTheme();

    return theme.palette.mode;
};
